<form [formGroup]="form" autocomplete="off" class="form-horizontal">

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="gruendungsart">{{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.GRUENDUNGSART.TITEL' | translate }}
        </label>
        <div class="col-sm-8">
            <select
                    class="form-control"
                    id="gruendungsart"
                    formControlName="gruendungsart"
                    datevMessagePath="gruendungsart{{objectId}}"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage
                    (ngModelChange)="clearGruendungsForm($event)">
                <option [ngValue]="null" disabled hidden
                        selected>{{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.GRUENDUNGSART.NULL' | translate }}</option>
                <option *ngFor="let value of enumKeys(gruendungsartEnum)"
                        [ngValue]="gruendungsartEnum[value]">{{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.GRUENDUNGSART.KEY_' + gruendungsartEnum[value].toUpperCase() | translate }}
                </option>
            </select>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label" for="gruendungsdatum">
            {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.GRUENDUNGSDATUM' | translate }}
        </label>
        <div class="col-sm-8">
            <date-picker
                    id="gruendungsdatum"
                    messagePath="gruendungsdatum"
                    formControlName="gruendungsdatum"
                    [isRequired]=true>
            </date-picker>
        </div>
    </div>

  <div *ngIf="showGruendungsformHinweis" class="form-row">
    <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.HINWEIS' | translate"
                    type="info">
    </common-ui-card>
  </div>


    <div *ngIf="data.gruendungsart && data.gruendungsart != gruendungsartEnum._1">
        <div class="mt-5x">

            <h3 class="mb-3x">
                {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.TITEL' | translate }}
            </h3>

            <div class="form-row mb-3x">
                <label class="col-sm-4"
                       for="vorherigesUnternehmenTyp">
                    {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.VORHERIGES_UNTERNEHMEN_TYP.TITEL' | translate }}
                </label>
                <div class="col-sm-8">
                    <select
                            class="form-control"
                            id="vorherigesUnternehmenTyp"
                            formControlName="vorherigesUnternehmenTyp"
                            datevMessagePath="vorherigesUnternehmenTyp{{objectId}}"
                            utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage
                            (ngModelChange)="clearVorherigerUnternehmen($event)">
                        <option [ngValue]="null" disabled hidden selected>
                            {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.VORHERIGES_UNTERNEHMEN_TYP.NULL' | translate }}
                        </option>
                        <option *ngFor="let value of enumKeys(vorherigesUnternehmenTypEnum)"
                                [ngValue]="vorherigesUnternehmenTypEnum[value]">
                            {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.VORHERIGES_UNTERNEHMEN_TYP.KEY_'
                        + vorherigesUnternehmenTypEnum[value].toUpperCase() | translate }}
                        </option>
                    </select>
                </div>
            </div>

            <common-ui-personenstamm-daten *ngIf="data.vorherigesUnternehmenTyp === 'NatPers'"
                                           [(data)]="data.vorherigerInhaber"
                                           [readonly]="readonly"></common-ui-personenstamm-daten>
            <common-ui-juristische-person *ngIf="data.vorherigesUnternehmenTyp === 'NNatPers'"
                                          [(data)]="data.vorherigesUnternehmen"
                                          [readonly]="readonly"></common-ui-juristische-person>

            <div *ngIf="data.vorherigesUnternehmenTyp" class="form-row">
                <label class="col-sm-4 col-form-label" for="vorherigesUnternehmenUstIdentifikationsnummer">
                    {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.USTID' | translate }}
                </label>
                <div class="col-sm-8">
                    <input class="form-control" datevMessagePath="vorherigesUnternehmenUstIdentifikationsnummer{{objectId}}"
                           formControlName="vorherigesUnternehmenUstIdentifikationsnummer"
                           id="vorherigesUnternehmenUstIdentifikationsnummer"
                           type="text" utilsCheckValidity
                           utilsControlState utilsMarkRequired
                           utilsValidationMessage/>
                </div>
            </div>

            <div *ngIf="data.vorherigesUnternehmenTyp && showWirtschaftsIdNummer" class="form-row">
                <label class="col-sm-4 col-form-label" for="vorherigesUnternehmenWirtschaftsIdNummer">
                    {{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}
                </label>
                <div class="col-sm-8">
                    <input class="form-control" datevMessagePath="vorherigesUnternehmenWirtschaftsIdNummer{{objectId}}"
                           formControlName="vorherigesUnternehmenWirtschaftsIdNummer"
                           id="vorherigesUnternehmenWirtschaftsIdNummer"
                           type="text" utilsCheckValidity
                           utilsControlState
                           utilsValidationMessage/>
                </div>
            </div>

            <div *ngIf="data.vorherigesUnternehmenTyp" class="mt-3x">
                <h5>
                    {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.STEUERNUMMERN' | translate }}
                </h5>

                <common-ui-steuernummer
                        [(data)]="data.vorherigesUnternehmenSteuernummer"
                        [readonly]="readonly">
                </common-ui-steuernummer>
            </div>

            <div *ngIf="data.vorherigesUnternehmenTyp" class="mt-3x">
                <h5>
                    {{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.VORHERIGESUNTERNEHMEN.ADRESSE' | translate }}
                </h5>
                <common-ui-inlandsadresse
                        [showInlandsAdresse]="true"
                        [(data)]="data.vorherigesUnternehmenAdresse"
                        [inlandRequiredStrasse]="true"
                        [readonly]="readonly">
                </common-ui-inlandsadresse>
            </div>

        </div>
    </div>

</form>
